var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      staticClass: "mfa-config-modal",
      attrs: { id: "mfa-configuration-modal" },
      on: { close: _vm.handleClose }
    },
    [
      this.flowStage == this.$constants.MFA.FLOW_STAGES.METHOD_CHOICE
        ? _c("div", { attrs: { id: "mfa-method-choice" } }, [
            _c("div", { staticClass: "mfa-modal-header" }, [
              _c("img", {
                staticClass: "mfa-title-icon",
                attrs: { src: "images/icons/ic-lock.svg" }
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-bold mb-2" }, [
                _vm._v(_vm._s(_vm.modalTitle))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "modal-pretext text-light" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.modalPretext) + "\n\t\t\t\t"),
                _c(
                  "a",
                  {
                    staticClass: "cursor-pointer",
                    attrs: { href: "https://help.stan.store/article/408-2fa" }
                  },
                  [_vm._v("Learn more")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mfa-choice-container mt-3" },
              [
                _c(
                  "AppButton",
                  {
                    staticClass: "mfa-choice-btn w-100 h-auto",
                    attrs: {
                      name: "mfa-authenticator-config-button",
                      size: "large",
                      outline: "",
                      "data-target": "#mfa-method-choice-modal"
                    },
                    on: { click: _vm.showQRData }
                  },
                  [
                    _c("div", { staticClass: "mfa-choice-row" }, [
                      _c("span", { staticClass: "mfa-choice-icon" }, [
                        _c("img", {
                          attrs: { src: "images/icons/ic-clock.svg" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _c("p", { staticClass: "h3 mb-1 font-semibold" }, [
                          _vm._v("Code from authenticator")
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "mb-0 font-regular text-light" },
                          [
                            _vm._v(
                              "Generate a one-time code in your authenticator app"
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                false
                  ? _c(
                      "AppButton",
                      {
                        staticClass: "mfa-choice-btn w-100 h-auto",
                        attrs: {
                          name: "mfa-phone-config-button",
                          size: "large",
                          disabled: "",
                          outline: "",
                          "data-target": "#mfa-method-choice-modal"
                        },
                        on: { click: _vm.showMFANotificationFlow }
                      },
                      [
                        _c("div", { staticClass: "mfa-choice-row" }, [
                          _c("span", { staticClass: "mfa-choice-icon" }, [
                            _c("img", {
                              attrs: { src: "images/icons/ic-message.svg" }
                            })
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _c("p", { staticClass: "h3 mb-1 font-semibold" }, [
                              _vm._v("Text me a code")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "mb-0 font-regular" }, [
                              _vm._v("Add and verify your phone number")
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.AUTHENTICATOR_APP
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "mfa-qr-data" } },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v(_vm._s(_vm.modalPretext))
                ])
              ]),
              _vm._v(" "),
              _vm.qrCodeView
                ? _c(
                    "div",
                    { staticClass: "mb-6" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "setup-code",
                          attrs: { id: "mfa-qr-code" }
                        },
                        [
                          _c("QrcodeVue", {
                            attrs: {
                              value: this.totpURI,
                              size: _vm.size,
                              level: "H"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "inner-pretext text-light" }, [
                        _vm._v("\n\t\t\t\tCan't scan the code?\n\t\t\t")
                      ]),
                      _vm._v(" "),
                      _c(
                        "AppButton",
                        {
                          staticClass: "w-100 pt-0",
                          attrs: { name: "mfa-cant-scan-code", link: "" },
                          on: {
                            click: function($event) {
                              _vm.qrCodeView = false
                            }
                          }
                        },
                        [_vm._v("\n\t\t\t\tView the setup key instead\n\t\t\t")]
                      )
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "mb-6" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "secret",
                          attrs: { id: "mfa-qr-secret" }
                        },
                        [_c("p", [_vm._v(_vm._s(this.secret))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "AppButton",
                        {
                          staticClass: "w-100 mb-3",
                          attrs: {
                            name: "mfa-copy-setup-key",
                            icon: "images/icons/ic-copy.svg",
                            size: "medium",
                            outline: "",
                            "data-target": "#mfa-configuration-modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyToClipboard(_vm.secret)
                            }
                          }
                        },
                        [_vm._v("\n\t\t\t\tCopy Setup Key\n\t\t\t")]
                      ),
                      _vm._v(" "),
                      _c(
                        "AppButton",
                        {
                          staticClass: "w-100",
                          attrs: {
                            name: "mfa-show-qr",
                            size: "medium",
                            link: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.qrCodeView = true
                            }
                          }
                        },
                        [_vm._v("\n\t\t\t\tScan QR code instead\n\t\t\t")]
                      )
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("p", { staticClass: "modal-pretext text-light" }, [
                _vm._v(
                  "\n\t\t\t2. Enter the one-time code from your authenticator\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("OTPInput", {
                attrs: {
                  error: _vm.error,
                  warning: _vm.warning,
                  "state-change-key": _vm.stateChangeKey,
                  "submit-button-text": "Continue"
                },
                on: {
                  resetErrors: _vm.resetWarningsAndErrors,
                  submit: _vm.validateConfigOTP
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.VERIFY_CODE
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "mfa-verify-code" } },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v("\n\t\t\t\tEnter the one-time code from "),
                  _c("strong", [_vm._v(_vm._s(_vm.modalPretext))]),
                  _vm._v(" to complete setup\n\t\t\t")
                ])
              ]),
              _vm._v(" "),
              _c("OTPInput", {
                attrs: {
                  error: _vm.error,
                  warning: _vm.warning,
                  "state-change-key": _vm.stateChangeKey,
                  "submit-button-text": "Continue"
                },
                on: {
                  resetErrors: _vm.resetWarningsAndErrors,
                  submit: _vm.validateConfigOTP
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.SAVE_RECOVERY_CODES
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "mfa-recovery-codes" } },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _c("strong", [_vm._v("You can only see this once ⚠️")]),
                  _vm._v(" " + _vm._s(_vm.modalPretext))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-button-group" }, [
                _c("div", { staticClass: "recovery-card" }, [
                  _c("img", {
                    staticClass: "copy-icon",
                    attrs: { src: "images/icons/ic-copy.svg", alt: "Copy" },
                    on: {
                      click: function($event) {
                        return _vm.copyToClipboard("recovery")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "recovery-text" }, [
                    _vm._v(_vm._s(this.recovery))
                  ])
                ]),
                _vm._v(" "),
                !_vm.isCopiedOrDownloaded
                  ? _c(
                      "div",
                      [
                        _c("p", { staticClass: "modal-pretext text-light" }, [
                          _vm._v(
                            "Download or copy your recovery code to continue"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "AppButton",
                          {
                            staticClass: "float-left mfa-complete-buttons",
                            attrs: {
                              name: "mfa-copy-recovery-codes",
                              outline: "",
                              size: "medium",
                              "data-target": "#mfa-configuration-modal"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyToClipboard("recovery")
                              }
                            }
                          },
                          [_vm._v("\n\t\t\t\t\tCopy\n\t\t\t\t")]
                        ),
                        _vm._v(" "),
                        _c(
                          "AppButton",
                          {
                            staticClass: "float-right mfa-complete-buttons",
                            attrs: {
                              name: "mfa-download-recovery-codes",
                              size: "medium",
                              "data-target": "#mfa-configuration-modal"
                            },
                            on: { click: _vm.downloadRecoveryCodes }
                          },
                          [_vm._v("\n\t\t\t\t\tDownload\n\t\t\t\t")]
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "d-flex recovery-save-action-card" },
                      [
                        _c("div", { staticClass: "action-text" }, [
                          _vm._v(
                            "Recovery Code " +
                              _vm._s(this.recoverySaveAction) +
                              "!"
                          )
                        ]),
                        _vm._v(" "),
                        _c("InlineSvg", {
                          staticClass: "check-mark-icon",
                          attrs: { src: "/images/icons/ic-check-circle.svg" }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "AppButton",
                      {
                        staticClass: "w-100 mb-2",
                        attrs: {
                          name: "mfa-saved-recovery-codes",
                          size: "medium",
                          "data-target": "#mfa-configuration-modal",
                          disabled: !_vm.isCopiedOrDownloaded
                        },
                        on: { click: _vm.showName }
                      },
                      [_vm._v("\n\t\t\t\t\tContinue\n\t\t\t\t")]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.NAME_CONFIGURATION
        ? _c(
            "div",
            {
              staticClass: "d-flex flex-column text-center",
              attrs: { id: "mfa-name-configuration" }
            },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v(_vm._s(_vm.modalPretext))
                ])
              ]),
              _vm._v(" "),
              _c("AppInput", {
                staticClass: "form-group mt-3",
                attrs: {
                  placeholder: _vm.$t("Authenticator app"),
                  name: "authenticator"
                },
                model: {
                  value: _vm.authenticatorName,
                  callback: function($$v) {
                    _vm.authenticatorName = $$v
                  },
                  expression: "authenticatorName"
                }
              }),
              _vm._v(" "),
              _c(
                "AppButton",
                {
                  staticClass: "w-100 float-right mfa-complete-buttons",
                  attrs: {
                    name: "mfa-continue-to-dashboard-button",
                    "data-target": "#mfa-configuration-modal",
                    type: "submit",
                    loading: _vm.finishSetuploading,
                    disabled:
                      !_vm.authenticatorName.trim() || _vm.finishSetuploading
                  },
                  on: { click: _vm.nameAndEnableConfiguration }
                },
                [_vm._v("\n\t\t\tFinish Setup\n\t\t")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.COMPLETE_CONFIGURATION
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "mfa-complete-setup" } },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("img", {
                  staticClass: "mfa-title-icon",
                  attrs: { src: "images/icons/ic-check-circle-purple.svg" }
                }),
                _vm._v(" "),
                _c("h3", { staticClass: "text-bold" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v("Your account is now much safer")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v(_vm._s(_vm.modalPretext))
                ])
              ]),
              _vm._v(" "),
              false
                ? _c(
                    "AppButton",
                    {
                      staticClass: "float-left mfa-complete-buttons",
                      attrs: {
                        name: "mfa-add-another-method-button",
                        outline: "",
                        "data-target": "#mfa-configuration-modal"
                      }
                    },
                    [_vm._v("\n\t\t\tAdd another method\n\t\t")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "AppButton",
                {
                  staticClass: "w-100 float-right mfa-complete-buttons",
                  attrs: {
                    name: "mfa-continue-to-dashboard-button",
                    "data-target": "#mfa-configuration-modal"
                  },
                  on: { click: _vm.completeMFAConfiguration }
                },
                [_vm._v("\n\t\t\tAwesome!\n\t\t")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.flowStage == this.$constants.MFA.FLOW_STAGES.RESTORE_CONFIGURATION
        ? _c(
            "div",
            { staticClass: "text-center", attrs: { id: "mfa-restore-setup" } },
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v(_vm._s(_vm.modalTitle))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light mb-4" }, [
                  _vm._v(_vm._s(_vm.modalPretext))
                ])
              ]),
              _vm._v(" "),
              _c(
                "AppButton",
                {
                  staticClass: "w-100 mb-2 float-right mfa-complete-buttons",
                  attrs: {
                    name: "mfa-restore-config-button",
                    "data-target": "#mfa-configuration-modal"
                  },
                  on: { click: _vm.restoreMFAConfiguration }
                },
                [_vm._v("\n\t\t\tSecure Your Account\n\t\t")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }